import { render, staticRenderFns } from "./BotaoPadrao.vue?vue&type=template&id=222b849c&scoped=true&"
import script from "./BotaoPadrao.vue?vue&type=script&lang=js&"
export * from "./BotaoPadrao.vue?vue&type=script&lang=js&"
import style0 from "./BotaoPadrao.vue?vue&type=style&index=0&id=222b849c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222b849c",
  null
  
)

export default component.exports